/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var GridView = require('psa-marionette/views/GridView');

var Backgrid = require('backgrid');
var MomentCell = require('common/backgrid/MomentCell');

function stripUnsafeHtml(htmlString) {
  const allowTags = new Set(['b', 'strong', 'br']);
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  
  const allElements = doc.body.querySelectorAll('*');

  allElements.forEach(element => {
    if (!allowTags.has(element.tagName.toLowerCase())) {
      const textNode = document.createTextNode(element.textContent);
      element.parentNode.replaceChild(textNode, element);
    }
  });
  return doc.body.innerHTML;
}

var HtmlCell = Backgrid.Cell.extend({
  render: function () {
    var htmlContent = stripUnsafeHtml(this.model.get(this.column.get("name")));
    this.$el.html(htmlContent);
    this.delegateEvents();
    return this;
  }
});

module.exports = GridView.extend({
  className: 'audit-log-view',

  options: {
    columns: [
      {
        name: 'createdBy',
        label: 'User',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'message',
        label: 'Action',
        cell: HtmlCell,
        headerCell: 'custom',
        width: 60,
        editable: false
      },
      {
        name: 'createdDate',
        label: 'Date',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateTimeFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 20,
        editable: false
      }
    ],
    emptyText: 'No Audit Log Entries',
    collection: this.collection || new Backbone.Collection()
  }
});
